import { FaBars } from "react-icons/fa";
import UserSelectedLogo from "components/UserSelectedLogo";
import Button, { ButtonVariant } from "components/Button";

interface TopBarProps {
  manifestation?: string;
  onMenuOpen: () => void;
}

function TopBar({ onMenuOpen, manifestation }: TopBarProps) {
  return (
    <div className="flex flex-row items-center px-2">
      <div className="w-fit h-fit">
        <Button
          variant={ButtonVariant.FlatNoBorder}
          icon={<FaBars />}
          onClick={onMenuOpen}
          size="lg"
        />
      </div>
      <div className="flex flex-row w-fit space-x-2 pt-2 items-center">
        <UserSelectedLogo />
        {manifestation ? (
          <div className="text-palette-2">{manifestation}</div>
        ) : null}
      </div>
    </div>
  );
}

export default TopBar;
